import { render, staticRenderFns } from "./solicitacaoIcons.vue?vue&type=template&id=7b28bc9e&scoped=true&"
import script from "./solicitacaoIcons.ts?vue&type=script&lang=ts&"
export * from "./solicitacaoIcons.ts?vue&type=script&lang=ts&"
import style0 from "./solicitacaoIcons.vue?vue&type=style&index=0&id=7b28bc9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28bc9e",
  null
  
)

export default component.exports